import { FC } from "react";
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const message: string =
  "Selecciona tu perfil para que podamos brindarte una atención personalizada.";

export const TooltipClientType: FC = () => {
  return (
    <Tooltip title={message}>
      <QuestionCircleOutlined />
    </Tooltip>
  );
};
